import templateStr from 'text!./templates/quote-offering.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            quoteId: '=',
            quote: '=gwQnbQuoteOffering',
            buy: '&'
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/directives/QuoteOffering.js
// module id = 2234
// module chunks = 0